// Rotating ticket QR — RFC 6238 TOTP (HMAC-SHA1) via Web Crypto, same payload as the app's src/utils/totp.ts:
// `FP1:<ticket_id>:<unix_seconds>:<6-digit TOTP>` where the timestamp is the start of the current step.
function hexBytes(hex) {
  const out = new Uint8Array(hex.length / 2);
  for (let i = 0; i < out.length; i++) out[i] = parseInt(hex.substr(i * 2, 2), 16);
  return out;
}

export async function totp(secretHex, at, step = 15, digits = 6) {
  const counter = Math.floor(at / step);
  const msg = new Uint8Array(8);
  const dv = new DataView(msg.buffer);
  dv.setUint32(0, Math.floor(counter / 0x100000000));
  dv.setUint32(4, counter >>> 0);
  const key = await crypto.subtle.importKey("raw", hexBytes(secretHex), { name: "HMAC", hash: "SHA-1" }, false, ["sign"]);
  const mac = new Uint8Array(await crypto.subtle.sign("HMAC", key, msg));
  const off = mac[19] & 0x0f;
  const bin = ((mac[off] & 0x7f) << 24) | (mac[off + 1] << 16) | (mac[off + 2] << 8) | mac[off + 3];
  return String(bin % 10 ** digits).padStart(digits, "0");
}

export async function ticketQr(ticketId, secretHex, serverNow, step = 15) {
  const ts = Math.floor(serverNow / step) * step;
  return `FP1:${ticketId}:${ts}:${await totp(secretHex, ts, step)}`;
}
